import { render, staticRenderFns } from "./topicCode.vue?vue&type=template&id=7fa85b4b"
import script from "./topicCode.vue?vue&type=script&lang=js"
export * from "./topicCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports